// extracted by mini-css-extract-plugin
export default {"fixed":"DSjcJ8"};